import { render, staticRenderFns } from "./SignupForm.vue?vue&type=template&id=ff076f10&scoped=true&"
import script from "./SignupForm.vue?vue&type=script&lang=ts&"
export * from "./SignupForm.vue?vue&type=script&lang=ts&"
import style0 from "./SignupForm.vue?vue&type=style&index=0&id=ff076f10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff076f10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Romppu/source/repos/poker-serverless/pokerapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VContainer,VForm,VLayout,VProgressCircular,VTextField})
